import { Controller } from '@hotwired/stimulus'
import $ from 'jquery'

const enterKeyCode = 13

export default class extends Controller {
  static targets = [
    'value',
    'unit',
    'customEmission',
    'submit',
    'source',
    'directTotal',
    'directInput',
    'amortization',
    'purchaseSource',
    'atLeastOneOption',
    'mandatoryRadioInput',
    'mandatoryRadioGroup'
  ]

  connect() {
    this.element.controller = this
    this.enableSubmit()
    $('.selectpicker').selectpicker({
      sanitizeFn: domNodes => domNodes
    })
  }

  is_visible(element) {
    return element.offsetParent !== null
  }

  visibleElements(elements) {
    if (elements) return elements.filter(this.is_visible)
  }

  get visibleDirectInputTargets() {
    return this.visibleElements(this.directInputTargets)
  }
  get visibleValueTargets() {
    return this.visibleElements(this.valueTargets)
  }
  get visibleUnitTargets() {
    return this.visibleElements(this.unitTargets)
  }
  get visibleCustomEmissionTargets() {
    return this.visibleElements(this.customEmissionTargets)
  }

  get directInputTargetsAreSet() {
    return this.visibleDirectInputTargets.some(t => t.value !== '')
  }
  get allValueTargetsAreSet() {
    return this.visibleValueTargets.every(t => t.value !== '')
  }
  unitTargetIsSet(value) {
    return !['', '-'].includes(value) && !value.match(/Choisir|Choose|Select|^\s*-\s*$/)
  }
  get allUnitTargetsAreSet() {
    return this.visibleUnitTargets.every(target => this.unitTargetIsSet(target.value))
  }
  get atLeastOneOptionTargetIsSet() {
    return this.atLeastOneOptionTargets.some(t => t.value !== '')
  }
  get amortizationTargetIsSet() {
    return this.visibleElements(this.amortizationTargets).every(target => parseInt(target.value) > 0)
  }

  get is_direct() {
    return this.hasSourceTarget && this.sourceTarget.value === 'direct'
  }
  get is_custom() {
    return this.hasSourceTarget && this.sourceTarget.value === 'custom'
  }
  get allRadioGroupHaveCheckedInput() {
    let allRadioGroupAreChecked = false
    this.mandatoryRadioGroupTargets.forEach(radioBlock => {
      let radioInputs = [...radioBlock.querySelectorAll('input[type="radio"]')]
      allRadioGroupAreChecked = this.someRadioButtonAreChecked(radioInputs)
    })
    return allRadioGroupAreChecked
  }

  get mandatoryRadioInputChecked() {
    if (this.hasMandatoryRadioGroupTarget) {
      console.log(this.allRadioGroupHaveCheckedInput)
      return this.allRadioGroupHaveCheckedInput
    } else if (this.hasMandatoryRadioInputTarget) {
      return this.someRadioButtonAreChecked(this.mandatoryRadioInputTargets)
    } else {
      return true
    }
  }

  someRadioButtonAreChecked(radioInputs) {
    return radioInputs.some(target => target.checked)
  }

  enableSubmit() {
    setTimeout(
      () =>
        this.submitTargets.forEach(target => {
          target.disabled = !this.valid()
        }),
      150
    )
  }

  valid = () => {
    if (this.hasAmortizationTarget && !this.amortizationTargetIsSet) return
    if (this.is_direct) {
      return this.mandatoryRadioInputChecked && this.directInputTargetsAreSet
    }
    if (this.is_custom) {
      if (this.visibleValueTargets.length === 0) return
      return this.allValueTargetsAreSet && this.selectedEmission() && this.mandatoryRadioInputChecked
    }
    if (this.hasUnitTarget && this.is_visible(this.unitTarget) && !this.allUnitTargetsAreSet) return
    if (this.hasPurchaseSourceTarget && !this.purchaseSourceTargets.some(target => target.checked)) return
    if (
      this.hasAtLeastOneOptionTarget &&
      this.is_visible(this.atLeastOneOptionTarget) &&
      !this.atLeastOneOptionTargetIsSet
    )
      return
    return this.allValueTargetsAreSet && this.mandatoryRadioInputChecked
  }

  selectedEmission = () => {
    if (this.visibleCustomEmissionTargets.length > 0) {
      return this.customEmissionTargets.some(target => target.classList.contains('active'))
    }
    return this.allValueTargetsAreSet
  }

  listenEnterKey(event) {
    if (event.keyCode === enterKeyCode && document.activeElement?.tagName !== 'TEXTAREA') {
      if (this.valid()) {
        this.submitTarget.click()
      }
      event.preventDefault()
    }
  }
}
